/**
 * The operative system in use
 */
export enum OperativeSystemName {
  /**
   * Google Android
   */
  Android = 'android',

  /**
   * Apple iOS
   */
  iOS = 'ios',

  /**
   * Microsoft Windows
   */
  Windows = 'windows',

  /**
   * Apple MacOS
   */
  MacOS = 'macos',

  /**
   * Linux
   */
  Linux = 'linux',

  /**
   * Other operating system not listed
   */
  Other = 'other',
}
